import { render, staticRenderFns } from "./AnimationMoodsSlider.vue?vue&type=template&id=1b54a979&scoped=true&"
import script from "./AnimationMoodsSlider.vue?vue&type=script&lang=js&"
export * from "./AnimationMoodsSlider.vue?vue&type=script&lang=js&"
import style0 from "./AnimationMoodsSlider.vue?vue&type=style&index=0&id=1b54a979&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54a979",
  null
  
)

export default component.exports